@if (loading()) {
  <vti-skeleton></vti-skeleton>
} @else {
  <vti-summary-table [summary]="summary"></vti-summary-table>
}
